import axios from "axios";

export const makePayment = async (token, params) => {
  try {
    const order = await createOrder(token, params);

    if (!order) {
      return false;
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: order.data.amount,
      currency: "INR",
      name: "Surgic Share",
      description: "Registration",
      order_id: order.data.id,
      handler: async (response) => {
        await sendNotification(token, params);
        window.location.href = `${process.env.REACT_APP_PAYMENT_URL}/payment-success?redirect=${params.redirectUrl}&type=${params.type}&app=${params.isMobile}`;
        // window.location.reload();
        return response; // This will be captured in the promise
      },
      prefill: {},
      notes: order.data.notes,
      theme: {
        color: "#0c2c54",
      },
      modal: {
        ondismiss: async () => {
          const cancelResponse = await cancelPayment(token, params);
          window.location.href = `${process.env.REACT_APP_PAYMENT_URL}/payment-cancel?redirect=${params.redirectUrl}&type=${params.type}&app=${params.isMobile}`;
          // window.location.reload();
          // console.log('Payment modal closed');
        },
      },
    };

    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;

      script.onload = () => {
        const rzp1 = new window.Razorpay(options);
        rzp1.open();

        rzp1.on("payment.failed", (response) => {
          console.log("Failed from Razorpay");
          reject(response); // Reject the promise with the response
        });

        options.handler = (response) => {
          resolve(response); // Resolve the promise with the response
        };
      };

      script.onerror = (error) => {
        reject(error); // Reject the promise if there's an error loading the script
      };

      document.body.appendChild(script);
    });
  } catch (error) {
    console.error("Failed", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};

export const submitTransactionId = async (token, data, transactionId) => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/users/service-api/v1/users/live-events/register`;
  const request = {
    id: data._id,
    booking_id: data.members?.booking_id,
    payment_reference_number: transactionId,
    amopunt: data.members?.amount,
    certificate_name: data.members?.certificate_name,
    coupon_code: data.members?.coupon_code ? data.members?.coupon_code : "",
    registration_number: data.members?.registration_number,
    transaction_status: "COMPLETED",
  };

  try {
    const response = await axios.post(apiUrl, request, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        "Unable to submit your transaction ID.",
    );
  }
};

const createOrder = async (token, data) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URL}/payments/service-api/v1/pay-sync/create-order`;
    // const token = localStorage.getItem("token");

    const config = {
      headers: {
        // Authorization: `Bearer ${JSON.parse(token)}`,
        Authorization: `Bearer ${token}`,
      },
    };

    const request = {
      payment_type: data.type,
      id: data._id,
      booking_id: data.members.booking_id,
    };

    const response = await axios.post(apiUrl, request, config);
    return response.data;
  } catch (error) {
    console.error("Error while creating order:", error);
    return error.message;
  }
};

export const closeWindow = async (token, data) => {
  const cancelRes = await cancelPayment(token, data);
};

const cancelPayment = async (token, data) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URL}/payments/service-api/v1/pay-sync/cancel-payment`;
    // const token = localStorage.getItem("token");

    const config = {
      headers: {
        // Authorization: `Bearer ${JSON.parse(token)}`,
        Authorization: `Bearer ${token}`,
      },
    };

    const request = {
      payment_type: data.type,
      id: data._id,
      booking_id: data.members.booking_id,
    };

    const response = await axios.post(apiUrl, request, config);
    return response.data;
  } catch (error) {
    console.error("Error while canceling:", error);
    return error.message;
  }
};

const sendNotification = async (token, data) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URL}/users/service-api/v1/users/push-notification/confirmation`;

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const request = {
      type: data.type,
      to_id: data._id,
      userId: data.members.user_id,
    };

    const response = await axios.post(apiUrl, request, config);
    return response.data;
  } catch (error) {
    console.error("Error while sending notification:", error);
    return error.message;
  }
};
